"use client";
import { Template } from "src/types";
import { componentMapDynamic } from "../../SelectedTemplateComponent";
import { mockConfig } from "../../constants/mockConfig";
import { useTheme } from "../../contexts/useTheme";
import Skeleton from "react-loading-skeleton";

const ContactSwitch = () => {
  const { config } = useTheme();
  const pageComponents = componentMapDynamic["contact"];
  const SelectedComponent =
    pageComponents[config?.template as Template] || pageComponents["design3"];

  if (!config?.template) {
    return <Skeleton width={`100vw`} height={`100vh`} />;
  }

  return <SelectedComponent styling={mockConfig.styling} />;
};

export default ContactSwitch;
